export class RateExtra {
  weightInc: number = null;
  fee: number = null;
  zones: RateExtraZone[] = [];
};

export class RateExtraZone {
  zoneCode: string;
  fee: number = null;

  constructor(zoneCode: string) {
    this.zoneCode = zoneCode;
  }
};
